import React from "react"
import { TableCell, Typography } from "@material-ui/core"
import { formatarCampoVazio } from '../../../shared/utils/Formatacao';

const TableCellText = (props) => (
  <TableCell style={{ width: props.width }}>
    <Typography color={props.color || "textSecondary"}>{formatarCampoVazio(props.text)}</Typography>
  </TableCell >
);

export default TableCellText;